export const APP_INSTALL_BANNER_ENABLED_FLAG_NAME: string = 'all_appinstallbanner_20201118';
